import error from "../../assets/svgs/404.svg";
import { Stack } from "@mui/material";

type Props = {};

const PageNotFound = (props: Props) => {
  return (
    <Stack
      direction={"column"}
      alignItems={"center"}
      justifyContent={"center"}
      width={"100%"}
      p={{ xs: 1, md: 5 }}
    >
      <img src={error} alt="Error-Page" width="500px" />
    </Stack>
  );
};

export default PageNotFound;
